import './styles.scss'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { getLocalLoggedInStatus, getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import CreateAccountInfoModal from 'Components/UIComponent/CreateAccountInfoModal'
import { ROUTE_STRINGS } from 'Utils/Constants'
import DropdownComponent from 'Components/DropdownComponent'
import CustomDropdown from 'Components/CustomDropdown'
import MetaTagsComponent from 'Components/MetaTagsComponent'
import useAnalytics from 'Utils/useAnalytics'
import { SCREEN_EVENTS, USER_EVENTS } from 'Utils/Constants/analyticsEvents'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import CountryWiseExportsReport from './Components/CountryWiseExportsReport'
import CommitmentOfTradersReport from './Components/CommitmentOfTradersReport'
import CertifiedStockReport from './Components/CertifiedStockReport'
import USDACoffeeReports from './Components/USDACoffeeReports'
import ICOCoffeeReport from './Components/ICOCoffeeReport'
import CountryWiseProductionReport from './Components/CountryWiseProductionReport'

const CoffeeStockReports = ({ coffeeStockReportsTestingFlag, coffeeStockReportsArabicFlag }) => {
  const coffeeReports = [
    {
      id: 1,
      report: 'Certified Stocks Report'
    },
    {
      id: 2,
      report: 'Commitment of Traders Report'
    },
    {
      id: 3,
      report: 'Country Wise Exports Report'
    },
    {
      id: 6,
      report: 'Country Wise Production Reports'
    },
    {
      id: 4,
      report: 'USDA Coffee Reports'
    },
    {
      id: 5,
      report: 'ICO Coffee Reports'
    }
  ]
  const marketName = [
    {
      idMarket: 1,
      marketName: 'Robusta',
      marketCode: 'R',
      searchCode: 'RC'
    },
    {
      idMarket: 2,
      marketName: 'Arabica',
      marketCode: 'F',
      searchCode: 'AC'
    }
  ]

  const { t } = useTranslation()
  const location = useLocation()
  const history = useHistory()
  const { realtimeSubscriptionData } = useContext(CoffeeWebContext)
  const fullPath = location.pathname
  const pathSegments = fullPath.split('/')
  const desiredPath = pathSegments[2] || ''
  const userDetails = getLocalUserDetails()
  const isUserLoggedIn = getLocalLoggedInStatus()
  const isAuthenticatedUser = Boolean(userDetails?.id || isUserLoggedIn)
  const realtimeSubscriptionName = (realtimeSubscriptionData?.subscriptionDetails?.SubscriptionName || '').trim()
  const subType = userDetails?.sub?.subType
  const hasRealtimeSubscription = Boolean(realtimeSubscriptionName)
  const isPlatinumUser = hasRealtimeSubscription ? realtimeSubscriptionName === 'Platinum' || realtimeSubscriptionName === 'Trial Platinum' : subType === 3

  const { setScreenLog, trackEvent } = useAnalytics()

  const params = new URLSearchParams(location.search)
  const reportFromParam = params.get('report')

  if (userDetails?.id && ROUTE_STRINGS.coffeeReports !== fullPath) {
    history.replace({ pathname: ROUTE_STRINGS.coffeeReports })
  }

  let menuLock

  if (userDetails && userDetails?.businessGeneralMenus?.businessMenu) {
    const menu = userDetails?.businessGeneralMenus?.businessMenu?.find(({ menuUrl }) => menuUrl?.includes(desiredPath))

    if (menu) {
      menuLock = menu.menulock
    }
  }
  const isMenuLock = (userDetails?.id && !isPlatinumUser) || menuLock

  const [coffeeReport, setCoffeeReports] = useState([])
  const [activeTab, setActiveTab] = useState('tab1')
  const [selectedMarket, setSelectedMarket] = useState('Robusta')

  useEffect(() => {
    if (!reportFromParam) {
      const defaultReportName = coffeeReports[0].report.toLowerCase().replace(/ /g, '-')

      params.set('report', defaultReportName)
      history.replace({ search: params.toString() })
      setCoffeeReports(coffeeReports[0])
    } else {
      const reportNameWithSpaces = reportFromParam.replace(/-/g, ' ')
      const matchedReport = coffeeReports.find((r) => r.report.toLowerCase() === reportNameWithSpaces)

      if (matchedReport) {
        setCoffeeReports(matchedReport)
      } else {
        setCoffeeReports(coffeeReports[0])
      }
    }
  }, [location.search])

  // useEffect to initialize state for testing purpose
  useEffect(() => {
    if (coffeeStockReportsTestingFlag) {
      setCoffeeReports(coffeeReports[coffeeStockReportsTestingFlag])
    } else if (coffeeStockReportsArabicFlag) {
      setSelectedMarket('Arabica')
    }

    const reportNameWithHyphens = coffeeReport?.report?.toLowerCase()?.replace(/ /g, '-')

    const userEvent = userDetails ? SCREEN_EVENTS.USER_COFFEE_REPORTS_SCREEN : SCREEN_EVENTS.GUEST_COFFEE_REPORTS_SCREEN

    setScreenLog(userEvent, { subscriptionType: userDetails?.sub?.subTypeName || 'Guest', country: userDetails?.userCountryDetails?.nicename || 'Guest' }) // user-analytics
    handleReportTracking(reportNameWithHyphens) // user-analytics
  }, [])

  const handleCoffeeReportsChange = (event) => {
    const chosenReport = event.target.value

    setCoffeeReports(chosenReport)
    setActiveTab('tab1')

    const reportNameWithHyphens = chosenReport?.report?.toLowerCase().replace(/ /g, '-')

    handleReportTracking(reportNameWithHyphens) // user-analytics
    params.set('report', reportNameWithHyphens)
    history.replace({ search: params.toString() })
  }

  const handleTabClick = (tab) => {
    setActiveTab(tab)
  }

  const handleReportTracking = (reportNameWithHyphens) => {
    trackEvent(USER_EVENTS.SELECTED_REPORT_NAME, {
      reportName: reportNameWithHyphens
    })
  }

  const getButtonAndInfo = () => {
    if (!userDetails) {
      return {
        buttonText: t('LOGIN_AND_CREATE_ACCOUNT'),
        infoMessage: t('TO_ACCESS_MORE_FEATURE_CREATE_ACCOUNT'),
        infoMessage2: t('TO_ACCESS_GLOBAL_DIFFERENTIAL_FEATURE'),
        className: 'login-button',
        navigationPath: ROUTE_STRINGS.login,
        state: {}
      }
    }
    if (userDetails.isTrialUser) {
      return {
        buttonText: t('BUY_TRIAL_SUBSCRIPTION'),
        infoMessage: t('TO_ACCESS_GLOBAL_DIFFERENTIAL_FEATURE'),
        className: 'buy-subscription-button',
        navigationPath: ROUTE_STRINGS.subscription,
        state: { subscriptionId: 4 }
      }
    }
    if (realtimeSubscriptionName === 'Regular' || subType === 1) {
      return {
        buttonText: t('BUY_SUBSCRIPTION'),
        infoMessage: t('TO_ACCESS_GLOBAL_DIFFERENTIAL_FEATURE'),
        className: 'buy-subscription-button',
        navigationPath: ROUTE_STRINGS.subscription,
        state: { subscriptionId: 3 }
      }
    }
    if (realtimeSubscriptionName === 'Gold' || subType === 2) {
      return {
        buttonText: t('UPGRADE'),
        infoMessage: t('TO_ACCESS_GLOBAL_DIFFERENTIAL_FEATURE'),
        className: 'buy-subscription-button',
        navigationPath: ROUTE_STRINGS.subscription,
        state: { subscriptionId: 3 }
      }
    }

    return {
      buttonText: t('LOGIN_AND_CREATE_ACCOUNT'),
      infoMessage: t('TO_ACCESS_MORE_FEATURE_CREATE_ACCOUNT'),
      className: 'login-button',
      navigationPath: ROUTE_STRINGS.login,
      state: {}
    }
  }

  const { buttonText, infoMessage, className, navigationPath, state } = getButtonAndInfo()

  const getTabsConfig = () => {
    if (coffeeReport?.id === 1) {
      return [
        { id: 'tab1', label: t('TOTAL_CERTIFIED_STOCKS') },
        { id: 'tab2', label: t('ALL_COUNTRY_CERTIFIED_STOCK') },
        { id: 'tab3', label: selectedMarket === 'Robusta' ? t('PORT_WISE_CERTIFIED_STOCK') : t('COUNTRYWISE_CERTIFIED_STOCK') }
      ]
    }
    // eslint-disable-next-line no-else-return
    else if (coffeeReport?.id === 2) {
      return [
        { id: 'tab1', label: t('LOTWISE_COMPARISON') },
        { id: 'tab2', label: t('WEEKLY_WISE_COT_REPORTS') },
        { id: 'tab3', label: t('TRADERWISE_COMPARISON') }
      ]
    }

    return []
  }

  const tabsConfig = getTabsConfig()

  return (
    <div className="coffee-reports-component" data-testid="coffee-reports-main-container">
      {!userDetails && <MetaTagsComponent title={t('COFFEE_REPORTS_TITLE')} description={t('COFFEE_REPORTS_DESCRIPTION')} keywords={t('COFFEE_REPORTS_KEYWORDS')} url="https://coffeeweb.com/coffee_reports" h1Content={t('COFFEE_REPORTS_H1_CONTENT')} />}
      <div className={coffeeReport?.id === 1 || coffeeReport?.id === 2 ? 'coffee-report-container' : 'country-wise-export-report'}>
        <div className="coffee-report-header" data-testid="coffee-reports-header-container">
          <div className="title">{coffeeReport?.id === 4 || coffeeReport?.id === 5 ? coffeeReport.report : t('COFFEE_REPORTS')}</div>
          <div className="coffee-report-dropdown" data-testid="coffee-report-dropdown-container">
            <CustomDropdown value={coffeeReport} options={coffeeReports} placeholder={coffeeReports?.length ? t('SELECT_REPORT') : t('NO_DATA_FOUND')} optionLabel={'report'} onChange={handleCoffeeReportsChange} className="coffee-report-selector" testId="coffee-report-dropdown" panelClassName="coffee-report-selector-panel" />
          </div>
        </div>

        {coffeeReport?.id === 1 && <CertifiedStockReport activeTab={activeTab} marketName={marketName} selectedMarket={selectedMarket} setSelectedMarket={setSelectedMarket} testingId="certified-stock-report-reusable-component" menuLock={isMenuLock} />}
        {coffeeReport?.id === 2 && <CommitmentOfTradersReport activeTab={activeTab} marketName={marketName} selectedMarket={selectedMarket} setSelectedMarket={setSelectedMarket} testingId="commitment-of-traders-reusable-component" menuLock={isMenuLock} />}
        {coffeeReport?.id === 3 && (
          <div className="coffee-report-table">
            <CountryWiseExportsReport testingId="country-wise-exports-report-reusable-component" menuLock={isMenuLock} />
          </div>
        )}
        {coffeeReport?.id === 4 && (
          <div className="coffee-report-table">
            <USDACoffeeReports menuLock={isMenuLock} />
          </div>
        )}
        {coffeeReport?.id === 5 && (
          <div className="coffee-report-table">
            <ICOCoffeeReport menuLock={isMenuLock} />
          </div>
        )}
        {coffeeReport?.id === 6 && (
          <div className="coffee-report-table">
            <CountryWiseProductionReport menuLock={isMenuLock} />
          </div>
        )}
      </div>

      {(coffeeReport?.id === 1 || coffeeReport?.id === 2) && (
        <div className="tab-wrapper" data-testid="coffee-report-tabs-wrapper">
          <div className="tab-container" data-testid="coffee-report-tab-container">
            {tabsConfig.map(({ id, label }) => (
              <React.Fragment key={label}>
                <input type="radio" name="tab" onChange={() => {}} id={id} className={`tab ${id}`} checked={activeTab === id} data-testid="tab-radio-input-field" />
                <label className="tab_label" htmlFor={id} onClick={() => handleTabClick(id)}>
                  {label}
                </label>
              </React.Fragment>
            ))}

            <div className="indicator" data-testid="radio-button-indicator-container"></div>
          </div>
        </div>
      )}

      {(!isAuthenticatedUser || isMenuLock) && (
        <div className={`coffee-reports-create-account-info-modal-popup ${coffeeReport?.id === 4 && 'usda-report-style'} ${coffeeReport?.id === 3 && 'country-wise-export-report-style'}  ${isUserLoggedIn ? 'create-account-info-message' : 'guest-create-account-info-message'}`} data-testid="coffee-reports-create-account-container">
          <CreateAccountInfoModal buttonText={buttonText} infoMessage={infoMessage} className={className} navigationPath={navigationPath} state={state} DropdownComponent={DropdownComponent} testId="coffee-reports-create-account-modal" />
        </div>
      )}
    </div>
  )
}

export default CoffeeStockReports
